import { Component, OnInit } from '@angular/core';
import { LessonPlanService } from 'src/app/services/LessonPlan/lesson-plan.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-other-planning',
  templateUrl: './other-planning.component.html',
  styleUrls: ['./other-planning.component.css']
})
export class OtherPlanningComponent implements OnInit {

  OtherPlanList=[];
  SubmittedSearch=false;
  Submitted=false;
  StaffList=[];
  TeacherMsg='';
  ActivityTypeList=[];
  ActivityPriorityList=[];
  ReportingManagerList=[];
  dropdownSettings: any = {};
  selectedItems: any = [];
  ClassList=[];

  constructor(private lessonplanservice: LessonPlanService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SearchModel = {
    ActivityTypeID: 0,
    ReportingManagerID: 0,
    FromDate: moment(new Date()).format('DD-MMM-YYYY'),
    ToDate: moment(new Date()).format('DD-MMM-YYYY'),
}

ClearSearch() {
    this.OtherPlanList = [];
    this.SubmittedSearch = false;
    this.SearchModel.ActivityTypeID = 0;
    this.SearchModel.ReportingManagerID = 0;
    this.SearchModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
    this.SearchModel.ToDate = moment(new Date()).format('DD-MMM-YYYY');
};



GetAllOtherPlan() {
    this.spinnerService.show();
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
   
    this.lessonplanservice.GetAllOtherPlan(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
        this.OtherPlanList = data.OtherPlanList;
       this.spinnerService.hide();
       this.globalHelper.CheckActionStatus(data);
    });
};

SaveUpdateModel = {
    OtherPlanningID:0,
    ActivityTypeID: 0,
    ReportingManagerID: 0,
    ActivityPriorityID: 0,
    Description: '',
    StartDate: '',
    EndDate: '',
    StaffIDs: '',
    StatusID: 1,
    ActivityType:'',
    TeacherArray:[],
   
}

ClearSave() {
    this.Submitted = false;
    this.SaveUpdateModel.OtherPlanningID = 0;
    this.SaveUpdateModel.ActivityTypeID = 0;
    this.SaveUpdateModel.ActivityPriorityID = 0;
    this.SaveUpdateModel.ReportingManagerID = 0;
    this.SaveUpdateModel.Description = '';
    this.SaveUpdateModel.StartDate = '';
    this.SaveUpdateModel.EndDate = '';
    this.SaveUpdateModel.StaffIDs = '';
    this.SaveUpdateModel.StatusID = 1;
    this.SaveUpdateModel.TeacherArray=[];
    this.TeacherMsg = '';
};

Edit(item) {
    this.selectedItems = [];

    var StaffIDs = item.StaffIDs != null ? item.StaffIDs.split(',') : '';
    for (var i = 0; i < this.StaffList.length; i++) {
      for (var j = 0; j < StaffIDs.length; j++) {
        if (StaffIDs[j] == this.StaffList[i].ItemId) {
          let item = {
            ItemId: this.StaffList[i].ItemId,
            ItemName: this.StaffList[i].ItemName
          }
          this.selectedItems.push(item)
          break;
        }
      }
    }


    this.SaveUpdateModel.TeacherArray = this.selectedItems;

    this.SaveUpdateModel.OtherPlanningID = item.OtherPlanningID;
    this.SaveUpdateModel.Description = item.Description;
    this.SaveUpdateModel.ActivityTypeID = item.ActivityTypeID;
    this.SaveUpdateModel.StatusID = item.StatusID;
    this.SaveUpdateModel.ReportingManagerID = item.ReportingManagerID;
    this.SaveUpdateModel.ActivityPriorityID = item.ActivityPriorityID;
    this.SaveUpdateModel.StartDate = moment(new Date()).format('DD-MMM-YYYY');
    this.SaveUpdateModel.EndDate = moment(new Date()).format('DD-MMM-YYYY');

};

ValidityState() {
    return this.SaveUpdateModel.ActivityTypeID == 0 || this.SaveUpdateModel.ActivityPriorityID == 0|| this.SaveUpdateModel.StaffIDs=='';
}

GetCommaTeacher() {
    var StaffIDs = '';
    for (var j = 0; j < this.SaveUpdateModel.TeacherArray.length; j++) {
        if (StaffIDs == '') {
            StaffIDs = this.SaveUpdateModel.TeacherArray[j].ItemId;
        }
        else {
            StaffIDs = StaffIDs + "," +  this.SaveUpdateModel.TeacherArray[j].ItemId;
        }
      }
     this.SaveUpdateModel.StaffIDs = StaffIDs;
}


SaveOtherPlan(valid) {
    this.TeacherMsg = '';
    this.GetCommaTeacher();
    this.Submitted = true;
    if (valid && !this.ValidityState()) {
       
        for (var j = 0; j < this.ActivityTypeList.length; j++) {
            if (this.ActivityTypeList[j].ItemId == this.SaveUpdateModel.ActivityTypeID) {
                this.SaveUpdateModel.ActivityType = this.ActivityTypeList[j].ItemName;
                break;
            }
        }

        this.SaveUpdateModel.StartDate =this.SaveUpdateModel.StartDate!=null?moment(this.SaveUpdateModel.StartDate).format('DD-MMM-YYYY'):'';
        this.SaveUpdateModel.EndDate =this.SaveUpdateModel.EndDate!=null?moment(this.SaveUpdateModel.EndDate).format('DD-MMM-YYYY'):'';
       
        this.spinnerService.show();
        this.lessonplanservice.SaveOtherPlan(JSON.stringify(this.SaveUpdateModel)).subscribe((data: any) => {
           this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
            if (this.SaveUpdateModel.OtherPlanningID == 0 && data.webResponse.Status) {
                this.ClearSave();
                this.GetAllOtherPlan();
            }
            else if (data.webResponse.Status) {
                this.GetAllOtherPlan();
            }

        });
    }
};

// Init and Lookup
ngOnInit() {
    this.dropdownSettings = {
        singleSelection: false,
        idField: 'ItemId',
        textField: 'ItemName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
      };
  this.GetAllActivityType();
  this.GetAllActivityPriority();
  this.GetAllReportingManager();
  this.GetAllTeacher();
  this.GetAllOtherPlan();
}


       
GetAllActivityType() {
   this.spinnerService.show();
    this.lookupservice.GetLookupsList('LPActivityType', '').subscribe((data: any) => {
        this.ActivityTypeList = data.LookupItems;
        this.spinnerService.hide();
    });
};

GetAllActivityPriority() {
  this.spinnerService.show();
    this.lookupservice.GetLookupsList('LPActivityPriority', '').subscribe((data: any) => {
        this.ActivityPriorityList = data.LookupItems;
        this.spinnerService.hide();
    });
};
GetAllTeacher = function () {
    var itemBo = {
        'ItemId': this.SaveUpdateModel.ReportingManagerID,
    };
    this.spinnerService.show();
    this.lookupservice.GetLookupsList('LPTeacherByReportingManger', JSON.stringify(itemBo)).subscribe((data: any) => {
        this.StaffList = data.LookupItems;
        this.StaffList.splice(0, 1);
        this.spinnerService.hide();
    });
};
GetAllReportingManager() {
  this.spinnerService.show();
    this.lookupservice.GetLookupsList('LPReportingManger', '').subscribe((data: any) => {
        this.ReportingManagerList = data.LookupItems;
        this.spinnerService.hide();
        
    });
};
 
}
